module.exports = __webpack_public_path__ + "static/media/Agri-Food Manufacturer Desktop 23-02-2024 C .a7a324e0.gif";